import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ReduxState } from '../../../utils/interface';
import { Report } from './types';

const endpoint = 'https://service.earthsense.co.uk/myair/api/v1/reports/text';

export default function useReports() {
  const [reports, setReports] = useState<Report[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const token = useSelector((state: ReduxState) => state.auth.bearerToken);

  useEffect(() => {
    if (!token) return;

    const fetchReports = async () => {
      try {
        const response = await fetch(endpoint, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error('Failed to fetch reports');
        }
        const data = await response.json();
        setReports(data);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('An error occurred'));
      } finally {
        setIsLoading(false);
      }
    };

    fetchReports();
  }, [token]);

  return { data: reports, isLoading, error };
}
